import dayjs from "dayjs";
import { forwardRef, useEffect, useState } from "react";

const BookingHtml = ({ item, index }) => {

  return (<div key={item?.id} className="delivery-note">

    <div className="row space-between drivername">
      <strong>{item?.driver?.name}</strong>
      <strong>{dayjs(item?.pickup_date).format('dddd, D MMM YYYY')}</strong>
    </div>

    <table className="table">
      <thead>
        <tr>
          <th>SL No.</th>
          <th>Booking Ref.</th>
          <th>{item?.pickup_details?.name}</th>
          <th>Delivery Items</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{index + 1}</td>
          <td>{item?.booking_id}</td>
          <td>{item?.pickup_details?.phone}</td>
          <td rowSpan={2}>
            <table class="ditemtable" style={{ width: '100%' }} cellSpacing={3}>
              <tr>
                <td>

                  {item?.products2?.map(i => {
                    return (<div style={{ border: '1px solid black', margin: '5px 0', padding: '5px' }}>
                      <strong>{i?.item_id} - {i?.product_title}</strong>
                      <p>{i?.status_text !== "" ? i.status_text : item?.status_text}</p>
                    </div>)
                  })}

                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td>
            <strong>Booking Notes:</strong>
            <p>{item?.description ? item?.description : '-'}</p>
          </td>
        </tr>
      </tbody>
    </table>

  </div >)
};


export const ComponentToPrint = forwardRef((props, ref) => {
  const [bookingData, setBookingData] = useState([]);

  useEffect(() => {
    let newBookingData = props?.bookingData?.map(i => {
      if (i?.driver?.id === props?.driver_id) {
        return i;
      }
      return null;
    });

    newBookingData = newBookingData?.filter(i => i !== null);

    setBookingData(newBookingData);
  }, [props]);

  return (<div ref={ref} style={{ padding: "50px" }}>
    <div className="print-wrapper">

      {/*<div className="header">
        <div className="border-box">
          <h2>First Klass Shipping Ltd</h2>
          <h3>DELIVERY NOTE</h3>
          <p>
            HQ: Unit 4, Unit 8 Summerhill Industrial Estate, 4 Goodman Street,
            Birmingham B1 2SS, UK
          </p>
          <p>Tel: +44 01212366274</p>
        </div>
      </div>*/}

      <div className="header">
        <div className="border-box">
          <h3>Booking Note</h3>
        </div>
      </div>

      {bookingData?.map((item, index) => {
        return <BookingHtml item={item} bookingData={bookingData} index={index} />
      })}

      {/* Styles */}
      <style>{`
        body {
          font-family: Arial, sans-serif;
        }

        .print-wrapper {
          padding: 20px;
        }

        .delivery-note {
          padding: 10px;
          margin-bottom: 25px;
        }

        .border-box {
          border: 2px solid #000;
          padding: 5px;
          text-align: center;
        }

        .header h2 {
          margin: 0;
          font-size: 18px;
        }

        .header h3 {
          margin: 3px 0;
          font-size: 14px;
        }

        .header p {
          margin: 2px 0;
          font-size: 11px;
        }

        .row {
          display: flex;
          margin: 10px 0;
        }

        .space-between {
          justify-content: space-between;
        }

        .table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 10px;
        }

        .table th {
          padding: 6px;
          font-size: 16px;
          vertical-align: top;
          text-align: left;
        }

        .table td {
          padding: 6px;
          font-size: 15px;
          vertical-align: top;
          text-align: left;
        }

        .total {
          margin-top: 10px;
        }

        .center {
          text-align: center;
          margin-top: 10px;
        }

        .section {
          margin-top: 10px;
        }

        .drivername{
          font-size: 20px;
          border-top: 1px solid #000;
          border-bottom: 1px solid #000;
          padding: 5px 0;
        }

        @media print {
          body {
            margin: 0;
          }

          .delivery-note {
            page-break-inside: avoid;
          }
        }
      `}</style>

    </div>
  </div>);
});